export const capitalizeFirstLetter = (word: string) => {
  const capitalized = word?.charAt(0).toUpperCase();
  const remainingLetters = word?.slice(1);
  return capitalized + remainingLetters;
};

export const uncapitalizeFirstLetter = (word: string) => {
  const capitalized = word?.charAt(0).toLowerCase();
  const remainingLetters = word?.slice(1);
  return capitalized + remainingLetters;
};

export const formattedValue = (value: any) => {
  const valueFormatted = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
  return valueFormatted;
};

export const handleExtraUsers = (maxUser: number, totalUser: number) => {
  if (maxUser && totalUser !== 0) return maxUser + totalUser;
};

export const handlePlanValueDivide = (
  value: number,
  installmentPlan: number,
) => {
  return value / installmentPlan;
};

export const handleDiscount = (totalCost: number, discount: number) => {
  return totalCost - discount || 0;
};

export const SumArrayOfNumbers = (numbersArray: Array<number>) => {
  let total = 0;
  if (numbersArray?.length > 0) {
    for (const number of numbersArray) {
      total += number;
    }
  }
  return total;
};

export const subtitleCapitalize = (text: any) => {
  const loweredText = text?.toLowerCase();
  const words = loweredText?.split(' ');
  for (let a = 0; a < words?.length; a++) {
    let w = words[a];

    const firstLetter = w[0];
    w = firstLetter.toUpperCase() + w.slice(1);

    words[a] = w;
  }
  return words?.join(' ');
};

export const trimString = (value: string, length: number) => {
  return value.length > length ? value.substring(0, length) + '...' : value;
};

const PLAN_PERIOD_LABEL: Record<string, string> = {
  mensal: 'mês',
  anual: 'ano',
  bianual: 'bianual',
  semestral: 'semestral',
};

export type PlanPrice = {
  value: number;
  period: string;
};

/**
 * Monta o par (valor, período) do rótulo de preço de um produto.
 *
 * `installmentValue` é o valor de UMA parcela. Em plano mensal a parcela já é
 * o valor do mês, então ela continua sendo exibida. Em plano não-mensal,
 * exibir a parcela seguida de "/ano" afirma um total que o cliente não paga --
 * aí vale o valor do contrato (`finalValue`, ou `totalCost` quando não há
 * desconto aplicado).
 *
 * Sem valor de contrato devolvemos a parcela com `period` vazio: é melhor
 * omitir o período do que afirmar um que não conseguimos comprovar.
 */
export const buildPlanPrice = (
  planFrequency: string | undefined,
  installmentValue: number | string | undefined,
  signature?: {
    finalValue?: number | string | null;
    totalCost?: number | string | null;
  } | null,
): PlanPrice => {
  const installment = Number(installmentValue) || 0;
  const period = PLAN_PERIOD_LABEL[planFrequency ?? ''] ?? '';

  if (planFrequency === 'mensal') return { value: installment, period };

  const contractValue =
    Number(signature?.finalValue) || Number(signature?.totalCost) || 0;

  if (period && contractValue > 0) return { value: contractValue, period };

  return { value: installment, period: '' };
};
